import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのRuleAndPolicyロゴアイコン
 */
export function ProductLogoMediumRuleAndPolicy({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        d="M6.35352 28.2353C6.35352 27.8455 6.66955 27.5294 7.0594 27.5294H11.2947C11.6845 27.5294 12.0006 27.8455 12.0006 28.2353V29.6471C12.0006 30.0369 11.6845 30.353 11.2947 30.353H7.0594C6.66955 30.353 6.35352 30.0369 6.35352 29.6471V28.2353Z"
        fill="#57D7D9"
      />
      <path
        d="M16.9418 28.2353C16.9418 27.8455 17.2578 27.5294 17.6476 27.5294H21.8829C22.2728 27.5294 22.5888 27.8455 22.5888 28.2353V29.6471C22.5888 30.0369 22.2728 30.353 21.8829 30.353H17.6476C17.2578 30.353 16.9418 30.0369 16.9418 29.6471V28.2353Z"
        fill="#57D7D9"
      />
      <path
        d="M27.53 28.2353C27.53 27.8455 27.846 27.5294 28.2359 27.5294H32.4712C32.861 27.5294 33.177 27.8455 33.177 28.2353V29.6471C33.177 30.0369 32.861 30.353 32.4712 30.353H28.2359C27.846 30.353 27.53 30.0369 27.53 29.6471V28.2353Z"
        fill="#57D7D9"
      />
      <path
        d="M8.47116 13.4118C8.47116 13.0219 8.7872 12.7059 9.17705 12.7059H9.88293V24.7059C9.88293 25.0957 9.56689 25.4118 9.17705 25.4118C8.7872 25.4118 8.47116 25.0957 8.47116 24.7059V13.4118Z"
        fill="white"
      />
      <path
        d="M15.177 12.7059V14.1177L9.88293 14.1177V12.7059H15.177Z"
        fill="white"
      />
      <path
        d="M31.0594 13.4118C31.0594 13.0219 30.7434 12.7059 30.3535 12.7059H29.6476V24.7059C29.6476 25.0957 29.9637 25.4118 30.3535 25.4118C30.7434 25.4118 31.0594 25.0957 31.0594 24.7059V13.4118Z"
        fill="white"
      />
      <path
        d="M20.4712 13.4118C20.4712 13.0219 20.1551 12.7059 19.7653 12.7059V12.7059C19.3754 12.7059 19.0594 13.0219 19.0594 13.4118V24.7059C19.0594 25.0957 19.3754 25.4118 19.7653 25.4118C20.1551 25.4118 20.4712 25.0957 20.4712 24.7059V13.4118Z"
        fill="white"
      />
      <path
        d="M24.3535 12.7059V14.1177L29.6476 14.1177V12.7059H24.3535Z"
        fill="white"
      />
      <path
        d="M13.4123 13.4118C13.4123 9.90315 16.2566 7.05884 19.7653 7.05884C23.2739 7.05884 26.1182 9.90315 26.1182 13.4118C26.1182 16.9204 23.2739 19.7647 19.7653 19.7647C16.2566 19.7647 13.4123 16.9204 13.4123 13.4118Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1384 10.8622C22.3222 10.6784 22.6201 10.6784 22.8039 10.8622L23.1367 11.1949C23.3205 11.3787 23.3205 11.6767 23.1367 11.8605L19.0678 15.9294C18.884 16.1131 18.586 16.1131 18.4022 15.9294L16.451 13.9781C16.2672 13.7943 16.2672 13.4964 16.451 13.3126L16.7837 12.9798C16.9675 12.7961 17.2655 12.7961 17.4492 12.9798L18.735 14.2656L22.1384 10.8622Z"
        fill="#1A2142"
      />
    </svg>
  );
}
